import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { FlexMiddle, Tooltip as BaseTooltip } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { getEmployeeDisplayName } from '@ubeya/shared-web/utils/employee';

const Wrapper = styled(FlexMiddle)`
  justify-content: center;
  position: relative;
  cursor: pointer;
  min-height: 70px;
  grid-area: 1 / 2 / 1 / -1;
  height: 60px;
  background: repeating-linear-gradient(
    -45deg,
    rgba(232, 232, 232),
    rgba(232, 232, 232) 2px,
    rgba(232, 232, 232, 0.2) 2px,
    rgba(232, 232, 232, 0.2) 6px
  );
  border-left: 1px solid ${({ theme }) => theme.colors.grey2};
`;

const Tooltip = styled(BaseTooltip)`
  .rc-tooltip-inner {
    text-align: center;
  }
`;

const ShiftsWrapper = styled(FlexMiddle)`
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  }
`;

const TimeOffRenderer = ({ data, employeeId, t, mappedJobTypes, employeesMap }) => {
  const { timeFormat, isShowLastNameFirst } = useContext(ConfigContext);

  const { startTime, endTime, jobTypeId } = data;

  const { firstName, lastName } = employeesMap?.[employeeId] || {};
  const name = useMemo(() => getEmployeeDisplayName(firstName, lastName, isShowLastNameFirst), [
    firstName,
    lastName,
    isShowLastNameFirst
  ]);

  const jobTypeLabel = mappedJobTypes?.[jobTypeId]?.label ? t(mappedJobTypes?.[jobTypeId]?.label) : '';
  const tooltip = `${name}${jobTypeLabel && ` | ${jobTypeLabel}`}, ${moment(startTime).format(timeFormat)} - ${moment(
    endTime
  ).format(timeFormat)}`;

  return (
    <Wrapper>
      <Tooltip body={tooltip}>
        <ShiftsWrapper />
      </Tooltip>
    </Wrapper>
  );
};

export default React.memo(TimeOffRenderer);
